import React from 'react';

interface PageSizeSelectorProps {
  pageSize: number;
  onPageSizeChange: (newPageSize: number) => void;
  pageSizeOptions: number[];
}

const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({ pageSize, onPageSizeChange, pageSizeOptions }) => (
  <div className="flex items-center gap-8">
    <span className="text-grey-700 text-sm">Show</span>
    <select
      value={pageSize}
      onChange={(e) => onPageSizeChange(Number(e.target.value))}
      className="border-grey-300 rounded-lg border px-2 px-4 py-1 text-sm focus:border-blue-500 focus:ring-blue-500"
    >
      {pageSizeOptions.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
    <span className="text-grey-700 text-sm">per page</span>
  </div>
);

export default PageSizeSelector;
